<template lang="html">
    <div>
        <div id="confirmBG" v-if="show"></div>
        <transition name="slideUp">
            <form class="lessonProConfirm" v-if="show">
                <p v-html="text"></p>
                <button @click.prevent="ok" class="button half" type="button" name="button">
                    {{ yesTxt }}
                </button>
                <button @click.prevent="cancel" class="button half red" type="button" name="button">
                    {{ noTxt }}
                </button>
            </form>
        </transition>
    </div>
</template>

<script>
export default {
    name: "lesson-pro-confirm",
    created() {
        this.eventHub.$on("update", ($data) => {
            this.text = $data["text"];

            this.yesTxt = $data["yes"] ? $data["yes"] : "Yes";
            this.noTxt = $data["no"] ? $data["no"] : "Cancel";

            this.show = true;
        });
    },
    data() {
        return {
            show: false,
            text: "",
            yesTxt: "Yes",
            noText: "Cancel",
        };
    },
    methods: {
        cancel() {
            this.show = false;
            this.eventHub.$emit("cancel");
        },
        ok() {
            this.show = false;
            this.eventHub.$emit("confirm");
        },
    },
};
</script>

<style lang="scss" scoped>
#confirmBG {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(68, 69, 71, 0.5);
    z-index: 35;
}
.lessonProConfirm {
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    background: white;
    padding: 40px 20px;
    z-index: 5000;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    border-top-right-radius: $radius;
    border-top-left-radius: $radius;
    z-index: 2000;
    p {
        text-align: center;
        color: $green_0;
        margin-bottom: 20px;
        line-height: 1.5;
    }
}
#confirmBg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1999;
    &.active {
        display: none;
    }
}
.slideUp-enter-active,
.slideUp-leave-active {
    transition: transform 0.3s;
    transform: translateY(0px);
}
.slideUp-enter, .slideUp-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateY(100%);
}

.fade-enter-active,
.fade-leave-active {
    transition: all 0.3s;
    opacity: 0;
}
.fadep-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 1;
}
</style>
